export class DataFilter {

	constructor(schoolData) {
		this.schoolData = schoolData
		// can refactor to use years in constructor instead of having extra object inbetween
		for (let year in schoolData) {
			this[`${year}`] = schoolData[year]
		}
	}

	getParentQsData(year) {
		let isNull = false
		if (this.schoolData.hasOwnProperty(year)) {
			if (this.schoolData[year].quality_service_A_plus === null || this.schoolData[year].quality_service_A === null || this.schoolData[year].quality_service_B === null) {
				isNull = true
			}
		} else {
			isNull = true
		}

		let parentQsData = {
			isNull: isNull
		}
		if (!isNull) {
			parentQsData.year = year
			parentQsData.aplus = this.schoolData[year].quality_service_A_plus
			parentQsData.a = this.schoolData[year].quality_service_A
			parentQsData.b = this.schoolData[year].quality_service_B
			parentQsData.lessb = 100 - this.schoolData[year].quality_service_A_plus - this.schoolData[year].quality_service_A - this.schoolData[year].quality_service_B
		}
		return parentQsData
	}

	getLetterGradeData(year) {
		let isNull = false
		if (this.schoolData.hasOwnProperty(year)) {
			if (this.schoolData[year].letter_grade === null) {
				isNull = true
			}
		} else {
			isNull = true
		}

		let letterGradeData = {
			isNull: isNull
		}
		if (!isNull) {
			letterGradeData.year = year
			letterGradeData.grade = this.schoolData[year].letter_grade
		}
		return letterGradeData
	}

	getAzMeritData(year) {
		let isNull = false
		if (this.schoolData.hasOwnProperty(year)) {
			if (this.schoolData[year].azmerit_math === null || this.schoolData[year].azmerit_ela === null) {
				isNull = true
			}
		} else {
			isNull = true
		}

		let azMeritData = {
			isNull: isNull
		}
		if (!isNull) {
			azMeritData.year = year
			azMeritData.math = this.schoolData[year].azmerit_math
			azMeritData.ela = this.schoolData[year].azmerit_ela
		}
		return azMeritData
	}

	getSatData(years) {
		let isNull = false
    years.forEach((e) => {
      if (this.schoolData.hasOwnProperty(e)) {
        if (this.schoolData[e].SAT_Math === null || this.schoolData[e].SAT_ela === null) {
          isNull = true
        }
      } else {
        isNull = true
      }
    })

		let satData = {
      isNull: isNull
    }
    if (!isNull) {
    	satData.years = years
      satData.math = years.map((e) => { return this.schoolData[e].SAT_math })
      satData.ela = years.map((e) => { return this.schoolData[e].SAT_ela })
    }
    return satData
	}

	getSatMathAverage(years) {
		let data = this.getSatData(years)

		if (!data.isNull) {
			data.mathavg = 0
			data.math.forEach((e, i) => {
				data.mathavg += e
			})
			data.mathavg = Math.floor(data.mathavg/data.math.length)
			data.width = data.mathavg / 800 * 100
		}
		return data
	}

	getSatElaAverage(years) {
		let data = this.getSatData(years)

		if (!data.isNull) {
			data.elaavg = 0
			data.ela.forEach((e, i) => {
				data.elaavg += e
			})
			data.elaavg = Math.floor(data.elaavg/data.ela.length)
			data.width = data.elaavg / 800 * 100
		}
		return data
	}

	getActData(years) {
		let isNull = false
    years.forEach((e) => {
      if (this.schoolData.hasOwnProperty(e)) {
        if (this.schoolData[e].ACT === null) {
          isNull = true
        }
      } else {
        isNull = true
      }
    })

		let actData = {
			isNull: isNull
		}
		if (!isNull) {
			actData.years = years
			actData.scores = years.map((e) => { return this.schoolData[e].ACT })
		}
		return actData
	}

	getActAverage(years) {
		let data = this.getActData(years)

		if (!data.isNull) {
			data.avg = 0
			data.scores.forEach((e, i) => {
				data.avg += e
			})
			data.avg = data.avg / data.scores.length
			data.width = data.avg / 36 * 100
		}
		return data
	}

}
